// extracted by mini-css-extract-plugin
export default {"mainInfo":"Home_mainInfo__QT10p"};